import { useTranslation } from "react-i18next";
import { useTariffLayer } from "@/store/mode";
import { CategoryGroup, Mode } from "@/types/base";
import {
  BikeIcon,
  CarIcon,
  ComfortCarIcon,
  ComfortPlusCarIcon,
  EconomCarIcon,
  KuperBagIcon,
} from "./icons";

export const useTariffOptions = () => {
  const { t } = useTranslation();
  const { tariffLayer, serviceLayer, setTariffLayer } = useTariffLayer();

  const modesByService: Record<CategoryGroup, Mode[]> = {
    taxi: [
      {
        id: "t_econom",
        label: t("tariffs.econom"),
        Icon: EconomCarIcon,
      },
      {
        id: "t_business",
        label: t("tariffs.comfort"),
        Icon: ComfortCarIcon,
      },
      {
        id: "t_comfortplus",
        label: `${t("tariffs.comfort")} +`,
        Icon: ComfortPlusCarIcon,
      },
    ],
    eda: [
      { id: "eda_car", label: t("tariffs.car"), Icon: CarIcon },
      { id: "eda_velo", label: "Вело", Icon: BikeIcon },
    ],
    kuper: [
      { id: "kuper", label: t("tariffs.walker"), Icon: KuperBagIcon },
      { id: "kuper_auto", label: t("tariffs.car"), Icon: CarIcon },
    ],
  };

  return {
    modes: modesByService[serviceLayer],
    selectedTariff: tariffLayer,
    selectTariff: setTariffLayer,
  };
};
